import { captureReactException } from "@sentry/react";

export const captureBoundaryError = (
  error: unknown,
  errorInfo: { componentStack?: string | null }
) => {
  captureReactException(error, errorInfo, {
    mechanism: { handled: false, type: "auto.function.react.error_handler" },
    captureContext: {
      tags: { errorBoundary: "react" },
      contexts: {
        route: {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash,
          timestamp: new Date().toISOString(),
        },
        errorInfo: { componentStack: errorInfo.componentStack },
      },
    },
  });
};
